module.exports = (elem, sourceKeypath) ->
	$elem = $ elem
	$input = $elem.find 'input'
	$plus = $elem.find '.plus'
	$minus = $elem.find '.minus'
	inputKeypath = @getNodeKeypath $input[0]
	step = 1

	@observe sourceKeypath, (newSource) ->
		return unless newSource
		step = newSource.step if newSource.step

	$plus.on 'click', =>
		@add inputKeypath, step

	$minus.on 'click', =>
		@subtract inputKeypath, step

	return {
		teardown: ->
	}


/** WEBPACK FOOTER **
 ** ./assets/coffee/decorators/numbers.coffee
 **/